import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Page } from '@strapi/strapi/admin';

import HomePage from './HomePage';
import EditorPage from './Editor';
import EmailLibrary from './EmailLibrary';

const App: React.FC = () => (
  <Routes>
    <Route index element={<HomePage />} />
    <Route path="library" element={<EmailLibrary />} />
    <Route path="new" element={<EditorPage mode="create" />} />
    <Route path=":id" element={<EditorPage mode="edit" />} />
    <Route path="*" element={<Page.Error />} />
  </Routes>
);

export { App };
export default App;
